"use client";

import { UserDetailReturnType } from "@/lib/declarations";
import useSWRFetcher from "../use-swr-fetcher";
import WalletBalance from "@/app/api/wallet-balances/type";

export default function useWalletBalances() {
  const { data, error, isLoading } = useSWRFetcher<WalletBalance>(`/api/wallet-balances`, {
    keepPreviousData: true,
    // revalidateOnFocus: false,
  });
  return [data, isLoading, error];
}
